/*
 *
 *  * Copyright(c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

export const enum REPORT_STATUS {
  UNKNOWN = 0,
  DISCARD = -2,
  DISCARD_ADDENDUM = -3,
  ASSOCIATING = 1,
  TEMPLATE_SELECTING = 100, // UI internal state indicates that report is in template selecting state on SR editor
  PENDING = 7100,
  PENDING_TEMPORARY = 7105,
  DRAFT = 7500, // Draft
  PRELIM = 7000, // PendingSignature
  PRELIM_PUBLISHED = 7001, // Prelim/Published
  FINAL = 9000, // Final
  ADDENDUM_PENDING = 9001,
  ADDENDUM_DRAFT = 9500, // Draft
  ADDENDUM_PRELIM = 9900, // PendingSignature
  ADDENDUM_PRELIM_PUBLISHED = 9901,

  TEMPORARY_MASK = 10,
  TEMPORARY_SIGN = 5
}

export const enum REPORTING_EVENT {
  OPEN = 'REPORT_OPENED',
  CLOSE = 'REPORT_CLOSED'
}

export const reportIdStatusMap = {
  0: 'Unknown', // Unknown
  1: 'Unknown', // Associating
  7000: 'Prelim', // Prelim
  7001: 'Prelim Published', // Prelim Distributed
  7005: 'Prelim Temporary', // Prelim Temporary
  7100: 'Pending', // Pending
  7105: 'Pending Temporary', // Pending Temporary
  7500: 'Draft', // Draft
  7505: 'Draft Temporary', // Draft Temporary
  7800: 'Pending Correction',
  8100: 'Corrected',
  8400: 'Correction Rejected',
  8700: 'Signature Rejected',
  9000: 'Final', // Final
  9001: 'Addendum Pending',
  9100: 'Addendum Corrected',
  9400: 'Addendum Correction Rejected',
  9500: 'Addendum Draft',
  9700: 'Addendum Signature Rejected',
  9800: 'Addendum Pending Correction',
  9900: 'Addendum Prelim',
  9901: 'Addendum Prelim Published'
};
